export default {
  strict: true,
  namespaced: true,
  state: {
    transactions: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      search: '',
      status: '',
      date: 'withinDay',
      dateFrom: '',
      dateTo: '',
      sort: {
        order: 'created',
        isDesc: true
      },
      loading: false
    }
  },
  mutations: {
    resetTransactions (state) { state.transactions.list = [] },
    addTransactions (state, value) { state.transactions.list.push(value) },
    resetTrxFilters (state) {
      state.transactions.search = ''
      state.transactions.status = ''
      state.transactions.date = 'withinDay'
      state.transactions.dateFrom = ''
      state.transactions.dateTo = ''
      state.transactions.loading = false
    },
    setTrxSearch (state, value) { state.transactions.search = value },
    setTrxStatus (state, value) { state.transactions.status = value },
    setTrxDate (state, value) { state.transactions.date = value },
    setTrxDateFrom (state, value) { state.transactions.dateFrom = value },
    setTrxDateTo (state, value) { state.transactions.dateTo = value },
    setTrxSortColumn (state, value) { state.transactions.sort.column = value },
    setTrxSortIsDesc (state, value) { state.transactions.sort.isDesc = value },
    setTrxLoading (state, value) { state.transactions.loading = value },
    setTrxMaxList (state, value) { state.transactions.maxList = value },
    setTrxCurrentPage (state, value) { state.transactions.currentPage = value },
    setTrxPerPage (state, value) { state.transactions.perPage = value },
    setUserOrder (state, value) { state.transactions.order = value },
    setUserOrderAsc (state, value) { state.transactions.orderAsc = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/corporate/transactions.js